var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FabSpacer'),_c('v-btn',_vm._b({class:{raised : _vm.isRaised},attrs:{"fixed":"","dark":"","fab":"","bottom":"","right":"","color":"accent"},on:{"click":_vm.click}},'v-btn',_vm.$attrs,false),[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }